import React, { FC, ReactElement } from 'react';

import { useRecoilValue } from 'recoil';

import { useContractReportNoticeModal } from '@hooks_iqfu/dashboard/useContractReportNoticeModal';

import { ContractReportNoticeModal } from '@components_iqfu/dashboard/contract_report_notice_modal/ContractReportNoticeModal';

import { spMenuOpenAtom } from '@recoil_iqfu/atoms/side_menu/spMenuOpen';

import DashboardMainArea from '@components_common/dashboard_main_area/DashboardMainArea';
import ProtectedRoutes from '@components_common/protected_routes/ProtectedRoutes';
import { UserType } from '@constants_common';

import styles from './DashboardPageContainer.module.scss';

type Props = {
  userType: UserType;
  rightColumn?: ReactElement;
  isCompanyMobile?: boolean;
};

const DashboardPageContainer: FC<Props> = ({ userType, rightColumn, isCompanyMobile = false, children }) => {
  const spMenuOpen = useRecoilValue(spMenuOpenAtom);
  const isCompanyUser = userType === 'company';
  const { isOpen: isContractReportNoticeModalOpen, onConfirm: onConfirmContractReportNoticeModal } =
    useContractReportNoticeModal(isCompanyUser);

  return (
    <ProtectedRoutes userType={userType}>
      <div className={styles.container}>
        {!spMenuOpen && (
          <DashboardMainArea userType={userType} hasRightColumn={!!rightColumn} isCompanyMobile={isCompanyMobile}>
            {children}
          </DashboardMainArea>
        )}
        <>{rightColumn}</>
      </div>
      {isCompanyUser && (
        <ContractReportNoticeModal
          open={isContractReportNoticeModalOpen}
          onConfirm={onConfirmContractReportNoticeModal}
        />
      )}
    </ProtectedRoutes>
  );
};

export default DashboardPageContainer;
